import { render } from "./QuestionActivity.vue?vue&type=template&id=1ca3df99&scoped=true&ts=true"
import script from "./QuestionActivity.vue?vue&type=script&lang=ts"
export * from "./QuestionActivity.vue?vue&type=script&lang=ts"

import "./QuestionActivity.vue?vue&type=style&index=0&id=1ca3df99&lang=sass&scoped=true"
import "./QuestionActivity.vue?vue&type=style&index=1&id=1ca3df99&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca3df99"]])

export default __exports__